import React, { useEffect } from "react";

type Props = {
  latitude: number;
  longitude: number;
  mapPinIcon: string;
};

declare let google: {
  maps: any;
};

const GOOGLE_MAP = "google-map";

const DetailMap: React.FC<Props> = ({ latitude, longitude, mapPinIcon }) => {
  const mapLatLang = { lat: latitude, lng: longitude };

  const mapStyles = [
    {
      featureType: "poi",
      stylers: [{ visibility: "off" }],
    },
  ];

  const mapOptions = {
    zoom: 16,
    center: mapLatLang,
    mapTypeId: "roadmap",
    disableDefaultUI: true,
    styles: mapStyles,
  };

  // TODO: install types/google.maps: https://developers.google.com/maps/documentation/javascript/using-typescript
  const initMap = (): void => {
    const map = new google.maps.Map(document.getElementById(GOOGLE_MAP) as HTMLElement, mapOptions);

    // eslint-disable-next-line no-new
    new google.maps.Marker({
      position: mapLatLang,
      map,
      icon: mapPinIcon,
    });
  };

  useEffect(() => {
    initMap();
  }, []);

  return (
    <div id={GOOGLE_MAP} className="h-[607px] w-[100%] rounded-[12px]" data-testid="google-map" />
  );
};

export default DetailMap;
